<template>
  <div>
    <!-- <div class="btn">
      <el-button type="primary"
                 @click="goToEdit()">新增模板</el-button>
    </div> -->
    <el-tabs v-model="activeName"
             @tab-click="handleClick">
      <el-tab-pane label="国内模板"
                   name="country">
        <div class="card-row">
          <el-card shadow="hover"
                   v-for="(item,index) in moduleList"
                   :key="index"
                   :style="{backgroundImage: 'url(' +url+ item.cover + ')'}">
            <div class="title">
              {{item.name}}
            </div>
            <div class="card-mask">
              <div class="mask-title">{{item.name}}</div>
              <div class="mask-handle">
                <a class="mask-title"
                   v-if="rules[item.id]"
                   :href="rules[item.id]">素材要求</a>
                <div @click="_preview(item.id)">预览</div>
              </div>

            </div>
          </el-card>
        </div>
      </el-tab-pane>
      <el-tab-pane label="海外模板"
                   name="oversea">
        <div class="card-row">
          <el-card shadow="hover"
                   v-for="(item,index) in moduleList"
                   :key="index"
                   :style="{backgroundImage: 'url(' +url+ item.cover + ')'}">
            <div class="title">
              {{item.name}}
            </div>
            <div class="card-mask">
              <div class="mask-title">{{item.name}}</div>
              <div class="mask-handle">
                <!-- <div @click="selectOne(item.id)">选此模板</div> -->
                <div @click="_preview(item.id)">预览</div>
              </div>
            </div>
          </el-card>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>
<script>
import { mapState } from 'vuex';
import axios from 'axios';
import api from '../api/api';


export default {
  data() {
    return {
      activeName: 'country',
      url: api.url,
      rules: {
        2: 'https://res.ijunhai.com/offical-rules/官网素材要求.xlsx',
        8: 'https://res.ijunhai.com/offical-rules/太古模版素材要求.xlsx',
        12: 'https://res.ijunhai.com/offical-rules/蚁族模版素材要求.xlsx',
      },
    };
  },
  created() {
    this.$store.dispatch('getModuleList', false);
  },
  computed: {
    ...mapState([
      'moduleList',
    ]),
  },
  methods: {
    handleClick(tab) {
      if (tab.name === 'country') {
        this.$store.dispatch('getModuleList', false);
      } else {
        this.$store.dispatch('getModuleList', true);
      }
    },
    _preview(id) {
      let loading2 = '';
      const that = this;
      loading2 = that.$loading({
        lock: true,
        text: '第一次初始化中，请稍候。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      axios.post(`${api.url}modulePre`, {
        template_id: id,
      }).then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          // eslint-disable-next-line no-use-before-define
          let timer = setInterval(getState, 2000);
          // eslint-disable-next-line no-inner-declarations
          function getState() {
            clearInterval(timer);
            axios
              .get(`${api.url}modulePreview`, {
                params: {
                  template_id: id,
                },
              })
              .then((resp) => {
                const myData = resp.data;
                if (myData.ret === 0) {
                  window.open(myData.url);
                  loading2.close();
                } else if (myData.ret === 3) {
                  timer = setInterval(getState, 2000);
                }
              });
          }
        } else if (data.ret === 3) {
          window.open(data.url);
          loading2.close();
        } else if (data.ret === 1) {
          loading2.close();
          that.$message({
            message: '预览失败，可能原因：模板进行过更新，预览数据没有更新，请联系开发人员~',
            type: 'error',
          });
        } else if (data.ret === -1) {
          loading2.close();
          that.$message({
            message: '单点登录超时~,请重新打包',
            type: 'error',
          });
        }
      });
    },
    // selectOne(id) {
    //   localStorage.setItem('webSite', '');
    //   localStorage.setItem('templateId', id);
    //   this.$store.commit('getWebSite', '');
    //   this.$store.commit('getTemplate', id);
    //   location.href = '#/websiteSet';
    // },
    goToEdit() {
      this.$router.push('/template/add');
    },
  },
};
</script>

<style >
.card-row {
  display: flex;
}
.el-card {
  height: 200px;
  width: 150px;
  background-size: cover;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  position: relative;
}
.el-card:hover > .el-card__body > .title {
  display: none;
}
.el-card:hover > .el-card__body > .card-mask {
  display: flex;
}
.el-card__body {
  padding: 0;
}
.title {
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  position: absolute;
  bottom: 0;
  line-height: 35px;
  color: #fff;
  text-align: center;
}
.card-mask {
  background: rgba(0, 0, 0, 0.4);
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  display: none;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.mask-title {
  margin-bottom: 20px;
}
.mask-handle {
  display: flex;
}
.mask-handle div {
  margin-left: 10px;
}
.mask-handle a {
  text-decoration: none;
  color: #fff;
}
.mask-handle div:hover {
  color: #409eff;
}
.mask-handle a:hover {
  color: #409eff;
}
.btn {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/TemplateConfig.vue